import React, { useState } from 'react';
import RegisterForm from './RegisterForm'

export default function Main(){        
    return <>
        <RegisterForm />
    </>
}

